<style lang="scss" scoped>
@import "./management.modal.scss";
</style>

<template>
    <div class="form-container">
        <div class="form-title">
            {{ integration.id ? "Editar Integração" : "Nova Integração" }}
        </div>

        <ValidationObserver ref="form" v-slot="{ invalid }">
            <div class="form-group">
                <div class="input-title">Tipo <span style="color: #CB595B;">*</span></div>
                <ValidationProvider rules="required" v-slot="v">
                    <div class="input-container">
                        <select v-model="integration.integration_type" class="input-value">
                            <option value="">Selecione o tipo</option>
                            <option v-if="entityType === 'client'" value="VAREJO_FACIL">VAREJO_FACIL</option>
                            <option v-if="entityType === 'provider'" value="TARGET">TARGET</option>
                            <option v-if="entityType === 'provider'" value="APS">APS</option>
                            <option v-if="entityType === 'provider'" value="WINTHOR">WINTHOR</option>
                            <option v-if="entityType === 'client'" value="WHATSAPP">WHATSAPP</option>
                            <option v-if="entityType === 'client'" value="RMS">RMS</option>
                        </select>
                    </div>
                    <span class="error">{{ v.errors[0] }}</span>
                </ValidationProvider>
            </div>

            <!-- VAREJO_FACIL Configuration -->
            <template v-if="integration.integration_type === 'VAREJO_FACIL'">
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                    <div class="form-group">
                        <div class="input-title">Subdomínio <span style="color: #CB595B;">*</span></div>
                        <ValidationProvider rules="required" v-slot="v">
                            <div class="input-container">
                                <input
                                    type="text"
                                    v-model="integration.configuration.subdomain"
                                    class="input-value"
                                    placeholder="Digite o subdomínio"
                                />
                            </div>
                            <span class="error">{{ v.errors[0] }}</span>
                        </ValidationProvider>
                    </div>

                    <div class="form-group">
                        <div class="input-title">API Key</div>
                        <div class="input-container">
                            <input
                                type="text"
                                v-model="integration.configuration.api_key"
                                class="input-value"
                                placeholder="Digite a API Key"
                            />
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-title">Username <span style="color: #CB595B;">*</span></div>
                        <ValidationProvider rules="required" v-slot="v">
                            <div class="input-container">
                                <input
                                    type="text"
                                    v-model="integration.configuration.username"
                                    class="input-value"
                                    placeholder="Digite o username"
                                />
                            </div>
                            <span class="error">{{ v.errors[0] }}</span>
                        </ValidationProvider>
                    </div>

                    <div class="form-group">
                        <div class="input-title">Password <span style="color: #CB595B;">*</span></div>
                        <ValidationProvider rules="required" v-slot="v">
                            <div class="input-container">
                                <input
                                    type="password"
                                    v-model="integration.configuration.password"
                                    class="input-value"
                                    placeholder="Digite a senha"
                                />
                            </div>
                            <span class="error">{{ v.errors[0] }}</span>
                        </ValidationProvider>
                    </div>

                    <div class="form-group">
                        <div class="input-title">Operation ID <span style="color: #CB595B;">*</span></div>
                        <ValidationProvider rules="required" v-slot="v">
                            <div class="input-container">
                                <input
                                    type="number"
                                    v-model.number="integration.configuration.operation_id"
                                    class="input-value"
                                    placeholder="Digite o Operation ID"
                                />
                            </div>
                            <span class="error">{{ v.errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
            </template>

            <!-- TARGET Configuration -->
            <template v-else-if="integration.integration_type === 'TARGET'">
                <div class="form-group">
                    <div class="input-title">URL <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                v-model="integration.configuration.url"
                                class="input-value"
                                placeholder="Digite a URL da API"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>

                <div class="form-group">
                    <div class="input-title">Username <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                v-model="integration.configuration.username"
                                class="input-value"
                                placeholder="Digite o username"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>

                <div class="form-group">
                    <div class="input-title">Password <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="password"
                                v-model="integration.configuration.password"
                                class="input-value"
                                placeholder="Digite a senha"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </template>

            <!-- APS Configuration -->
            <template v-else-if="integration.integration_type === 'APS'">
                <div class="form-group">
                    <div class="input-title">API Key <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                v-model="integration.configuration.api_key"
                                class="input-value"
                                placeholder="Digite a API Key"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <div class="input-title">URL <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                v-model="integration.configuration.url"
                                class="input-value"
                                placeholder="Digite a URL da API"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </template>

            <!-- WINTHOR Configuration -->
            <template v-else-if="integration.integration_type === 'WINTHOR'">
                <div class="form-group">
                    <div class="input-title">URL <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                key="winthor-url"
                                type="text"
                                v-model="integration.configuration.url"
                                class="input-value"
                                placeholder="Digite a URL da API Winthor"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>

                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                    <div class="form-group">
                        <div class="input-title">Login <span style="color: #CB595B;">*</span></div>
                        <ValidationProvider rules="required" v-slot="v">
                            <div class="input-container">
                                <input
                                    key="winthor-login"
                                    type="text"
                                    v-model="integration.configuration.login"
                                    class="input-value"
                                    placeholder="Digite o login"
                                />
                            </div>
                            <span class="error">{{ v.errors[0] }}</span>
                        </ValidationProvider>
                    </div>

                    <div class="form-group">
                        <div class="input-title">Senha <span style="color: #CB595B;">*</span></div>
                        <ValidationProvider rules="required" v-slot="v">
                            <div class="input-container">
                                <input
                                    key="winthor-senha"
                                    type="password"
                                    v-model="integration.configuration.senha"
                                    class="input-value"
                                    placeholder="Digite a senha"
                                />
                            </div>
                            <span class="error">{{ v.errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>

                <div class="form-group">
                    <div class="input-title">Branch ID <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                key="winthor-branch-id"
                                type="text"
                                v-model="integration.configuration.branch_id"
                                class="input-value"
                                placeholder="Digite o ID da filial"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </template>

            <!-- RMS Configuration -->
            <template v-else-if="integration.integration_type === 'RMS'">
                <div class="form-group">
                    <div class="input-title">Base URL <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                v-model="integration.configuration.base_url"
                                class="input-value"
                                placeholder="Digite a Base URL da API"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <div class="input-title">API Key <span style="color: #CB595B;">*</span></div>
                    <ValidationProvider rules="required" v-slot="v">
                        <div class="input-container">
                            <input
                                type="text"
                                v-model="integration.configuration.api_key"
                                class="input-value"
                                placeholder="Digite a API Key"
                            />
                        </div>
                        <span class="error">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </template>

            <!-- WHATSAPP Configuration -->
            <template v-else-if="integration.integration_type === 'WHATSAPP'">
                <div class="form-group">
                    <div class="input-title">Configurações de Envio</div>
                    <div class="checkbox-group">
                        <Checkbox v-model="integration.configuration.on_request_created" label="Envio de cotação" />
                        <Checkbox v-model="integration.configuration.on_invitation_created" label="Envio de convite" />
                        <Checkbox v-model="integration.configuration.on_order_created" label="Envio de pedido" />
                        <Checkbox v-model="integration.configuration.on_order_canceled" label="Cancelamento do Pedido" />
                    </div>
                </div>
            </template>

            <div class="form-group">
                <Checkbox v-model="integration.is_active" label="Ativo" />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Checkbox from "@/components/ui/inputs/checkbox.component.vue";

export default {
    name: "IntegrationFormComponent",
    components: {
        ValidationProvider,
        ValidationObserver,
        Checkbox,
    },
    props: {
        integration: {
            type: Object,
            required: true,
        },
        entityType: {
            type: String,
            required: false,
            default: "client",
        },
    },
};
</script>
